/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import _ from 'lodash';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';

import * as integrationsActions from '@ibm-watson/shared/modules/channels/store/channels/classic/actions';
import { selectIntegrationById } from '@ibm-watson/shared/modules/channels/store/channels/selectors';
import { getUser } from '@ibm-watson/shared/modules/ia/store/session/selectors';
import localStorage from '@ibm-watson/shared/modules/ia/util/localStorage';
import { go } from '@ibm-watson/shared/modules/ia/util/router/state';
import { pageEvents } from '@ibm-watson/shared/modules/ia/util/trackers/segment';
import { getStore } from '../../store/index';

export class IntercomOAuth extends Component {
  static propTypes = {
    location: ReactRouterPropTypes.location,
    user: PropTypes.object
  };

  componentDidMount() {
    pageEvents.oauth();
    this.connectIntercom();
  }

  render() {
    return null;
  }

  connectIntercom = async () => {
    // App.js also calls this when the user logs in, but the callstack doesn't fall in our favor.
    localStorage.setContext(this.props.user.username);
    const obj = JSON.parse(localStorage.get('integrationOAuth'));
    if (obj) {
      const parsedToken = queryString.parse(this.props.location.search);
      const { token } = parsedToken;
      const { assistantId, integrationId } = obj;
      // this.unsubscribe = getStore().subscribe(async () => {
      await getStore().dispatch(
        integrationsActions.listIntegrations(assistantId)
      );
      const { session } = getStore().getState();
      const integration = selectIntegrationById(
        getStore().getState(),
        integrationId
      );
      if (session && integration) {
        getStore().dispatch(
          integrationsActions.setShowClassicIntegration(
            true,
            integration.integration_id,
            integration.type
          )
        ); // show the integration immediately
        await getStore().dispatch(
          integrationsActions.unsubscribeIntegration({ integration })
        );
        await getStore().dispatch(
          integrationsActions.subscribeIntegration({
            integration,
            data: { access_token: token }
          })
        );

        if (!_.isEmpty(_.get(integration, 'settings.subscription_id'))) {
          await getStore().dispatch(
            integrationsActions.describeIntegration({
              integration
            })
          );
        }

        getStore().dispatch(
          integrationsActions.setShowClassicIntegration(
            true,
            integration.integration_id,
            integration.type
          )
        );
        //TODO clear the localStorage
      }
      // });
      go('assistant', obj);
    } else {
      go('assistants', {});
    }
  };
}

const mapStateToProps = state => ({
  user: getUser(state)
});

export default connect(mapStateToProps)(IntercomOAuth);
